import {aiHtmlPreviewController} from "./ai-html-preview.controller";
import template from "./ai-html-preview.html";
import "./ai-html-preview.scss";

export const aiHtmlPreviewComponent = {
    template,
    controller: aiHtmlPreviewController,
    controllerAs: "ai",
    bindings:{
        prWidth: "@",
        prHeight: "@",
        index: "@",
        displaySlider: "<"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/ai-html-preview/ai-html-preview.component.js